import { colors } from '@insurancemenu/imenu-components-lib';
import styled, { css, CSSProp } from 'styled-components';
import { StatusTagTypes } from './index';

export const TagStyled = styled.div<{ $status: StatusTagTypes }>`
  font-size: 1.4rem;
  line-height: 2rem;
  font-weight: 700;
  text-align: center;
  color: ${colors.neutral.white};
  vertical-align: middle;
  padding: 0.4rem 1rem;
  border-radius: 14px;
  min-width: 8rem;

  ${({ $status }): CSSProp => {
    switch ($status) {
      case StatusTagTypes.ELIGIBLE:
        return css`
          background-color: ${colors.green[600]};
        `;
      case StatusTagTypes.NOT_ELIGIBLE:
        return css`
          background-color: ${colors.red[600]};
        `;
      case StatusTagTypes.UPDATED_RATES:
        return css`
          background-color: ${colors.orange[500]};
        `;
      case StatusTagTypes.OVERRIDE:
        return css`
          background-color: ${colors.purple[600]};
        `;
      default:
        return css`
          background-color: ${colors.neutral[200]};
        `;
    }
  }};
`;
